function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { qs } from '../../common/utils/dom';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
const Target = /*#__PURE__*/forwardRef(({
  as: Component = 'button',
  eventKey,
  disabled,
  children,
  ...props
}, targetRef) => {
  const ref = useRef(null);
  const [hasInstance, setHasInstance] = useState(false);
  useEffect(() => {
    if (!hasInstance) return;
    const element = ref.current;
    const target = qs(`[data-collapsible="${eventKey}"]`);
    const targetCollapseInstance = target?.neu?.collapse;

    if (targetRef) {
      if (typeof targetRef === "function") {
        targetRef(targetCollapseInstance);
      } else {
        targetRef.current = targetCollapseInstance;
      }
    }

    targetCollapseInstance?.triggerRegister(element);
    return () => {
      if (targetRef) {
        if (typeof targetRef === "function") {
          targetRef(null);
        } else {
          targetRef.current = null;
        }
      }

      targetCollapseInstance?.triggerUnregister(element);
    };
  }, [hasInstance]);
  useEffect(() => {
    let times = 0;
    const cleanup = setInterval(() => {
      const target = qs(`[data-collapsible="${eventKey}"]`);
      const targetCollapseInstance = target?.neu?.collapse;

      if (targetCollapseInstance) {
        clearInterval(cleanup);
        setHasInstance(true);
      } else if (times > 5) {
        clearInterval(cleanup);
        console.error(`[data-collapsible="${eventKey}"] is cannot be found`);
      }

      times++;
    }, 1000);
    return () => clearInterval(cleanup);
  }, []);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    "data-disabled": disabled,
    "data-collapse": eventKey
  }), children);
});
export default Target;